import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { pathname } = useLocation();

  const links = [
    { label: 'Home', to: '/' },
    { label: 'About Us', to: '/about' },
    { label: 'Programme', to: '/programme' },
    { label: 'Kalaripayattu', href: '/kalaripayattu' },
    { label: 'Blog', to: '/blog' },
    { label: 'Contact', to: '/contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1C1917]/95 backdrop-blur-sm border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="font-heading text-lg font-bold text-white tracking-wide shrink-0">
          The Kalari Movement
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map(({ label, to, href }) => href ? (
            <a key={href} href={href}
              className="text-sm font-medium transition-colors text-white/75 hover:text-white"
            >
              {label}
            </a>
          ) : (
            <Link
              key={to} to={to}
              className={`text-sm font-medium transition-colors ${pathname === to ? 'text-[#DDA15E]' : 'text-white/75 hover:text-white'}`}
            >
              {label}
            </Link>
          ))}
        </div>

        <div className="hidden md:block">
          {user ? (
            <Link to="/dashboard" className="bg-[#9A3B26] hover:bg-[#7A2E1E] text-white text-sm font-medium px-5 py-2 rounded-full transition-colors">
              My Dashboard
            </Link>
          ) : (
            <Link to="/auth?mode=login" className="bg-[#9A3B26] hover:bg-[#7A2E1E] text-white text-sm font-medium px-5 py-2 rounded-full transition-colors">
              Login
            </Link>
          )}
        </div>

        <button onClick={() => setOpen(!open)} className="md:hidden text-white p-1">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#1C1917] border-t border-white/10 px-6 py-5 space-y-4">
          {links.map(({ label, to, href }) => href ? (
            <a key={href} href={href} onClick={() => setOpen(false)}
              className="block text-sm font-medium text-white/75"
            >
              {label}
            </a>
          ) : (
            <Link
              key={to} to={to} onClick={() => setOpen(false)}
              className={`block text-sm font-medium ${pathname === to ? 'text-[#DDA15E]' : 'text-white/75'}`}
            >
              {label}
            </Link>
          ))}
          <div className="pt-2">
            {user ? (
              <Link to="/dashboard" onClick={() => setOpen(false)} className="block bg-[#9A3B26] text-white text-sm font-medium px-4 py-2.5 rounded-full text-center">
                My Dashboard
              </Link>
            ) : (
              <Link to="/auth?mode=login" onClick={() => setOpen(false)} className="block bg-[#9A3B26] text-white text-sm font-medium px-4 py-2.5 rounded-full text-center">
                Login
              </Link>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
